import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCFCdthMS7i0zLK_cQvvPX0_VAnf3Cy4oI",
  authDomain: "insightpulse-ai-5960.firebaseapp.com",
  projectId: "insightpulse-ai-5960",
  storageBucket: "insightpulse-ai-5960.firebasestorage.app",
  messagingSenderId: "1061073168361",
  appId: "1:1061073168361:web:e2c5091c17c86ea06b0d78",
  measurementId: "G-DTN8HT6KFX"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);